function alertmessg (idd){
    var title = $('.product-converter__title div h1').text().trim();
    $('.product-converter__error[data-id="'+idd+'"]').html(`<span class="icon loaded">error</span><p>Je kunt geen ${title} meer aan je winkelwagen toevoegen.</p>`)
}

function adds(){
  $('.cart-item__quantity.data_matches').each(function(){
  var cart = $(this).attr('item-qty');
  var product = $(this).attr('data-qty');
  var idd = $(this).attr('data-id');
  if(product == cart){
  alertmessg (idd);
  $('.data_matches[data-id="'+idd+'"] button[name="plus"]').addClass('disable');
  $(this).find('button[name="plus"]').addClass('disable');
  }
  });
}

$(document).ready(function(){
adds();
});

! function() {
    "use strict";
    var t, e = {
            4105: function(t, e, n) {
                n.d(e, {
                    Q2: function() {
                        return o
                    },
                    gp: function() {
                        return s
                    },
                    hO: function() {
                        return r
                    }
                });
                const o = function() {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length>0&&void 0!==arguments[0]?arguments[0]:"json"}`
                            }
                        }
                    },
                    r = function() {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const e = window.innerWidth - document.body.offsetWidth,
                            n = document.getElementById("nav-wrapper");
                        t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", n.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", n.style.paddingRight = "0px")
                    };
                let a = () => {};
                const c = t => {
                        "Escape" === t.key && (a(), window.removeEventListener("keydown", c))
                    },
                    s = function() {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            e = arguments.length > 1 ? arguments[1] : void 0;
                        e && (a = e), t && window.addEventListener("keydown", c), t || window.removeEventListener("keydown", c)
                    };
                document.querySelectorAll(".local-scroll").forEach((t => {
                    t.addEventListener("click", (t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        (t => {
                            Math.easeInOutQuad = function(t, e, n, o) {
                                return (t /= o / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
                            };
                            const e = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let o = 0,
                                r = 0;
                            e && (o = e.offsetHeight + 50), n && (r = n.offsetHeight + 50);
                            const a = t.offsetTop - o - r,
                                c = window.scrollY,
                                s = a - c;
                            let i = 0;
                            const d = () => {
                                i += 5;
                                const t = Math.easeInOutQuad(i, c, s, 200);
                                window.scrollTo(0, t), i < 200 && setTimeout(d, 5)
                            };
                            d()
                        })(document.querySelector(e))
                    }))
                }))
            }
        },
        n = {};

    function o(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var a = n[t] = {
            exports: {}
        };
        return e[t](a, a.exports, o), a.exports
    }
    o.d = function(t, e) {
        for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        })
    }, o.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, t = o(4105), (() => {
        const e = document.querySelectorAll('form[action="/cart/add"]'),
            n = document.getElementById("main-cart"),
            o = document.getElementById("overlay"),
            r = document.getElementById("mini-cart"),
            a = document.querySelector("cart-service"),
            c = document.querySelector("body"),
            s = () => {
                r.classList.remove("open"), o.classList.remove("open"), c.style.removeProperty("overflow"), (0, t.hO)(!1)
            };
        e.length && e.forEach((e => e.addEventListener("submit", (c => {
            c.preventDefault(), c.stopPropagation(), c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`), c.target.querySelector('button[type="submit"]').classList.add("added"), c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "block";
            const i = (0, t.Q2)("javascript");
            i.headers["X-Requested-With"] = "XMLHttpRequest", delete i.headers["Content-Type"];
            const d = new FormData(e);
            d.append("sections", "main-cart"), i.body = d, fetch(`${routes.cartAdd}`, i).then((t => t.json())).then((async e => {
                if (e.status) {
                    if (c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "inline-flex", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none", c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof e.description) return Object.entries(e.description).forEach((t => {
                        let [e, n] = t;
                        const o = `${n.join(", ")}`;
                        c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + o + "</p>"
                    }));
                    c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>"
                } else {
                    if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
                    c.target.querySelector(".product-converter__error").innerHTML = "", n && n.classList.add("added"), a.renderItems((new DOMParser).parseFromString(e.sections["main-cart"], "text/html")), "mini-cart" === cartStrings.uxCart && (r && r.classList.add("open"), o && (o.classList.add("open", "overlay--all"), (0, t.hO)(!0), (0, t.gp)(!0, s))), c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), c.target.querySelector('button[type="submit"]').classList.remove("added"), c.target.querySelector('button[type="submit"]').classList.add("successful"), c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "flex", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none"
                }
            })).catch((t => {
                console.error("Error:", t)
            }))
          setTimeout(function() {
            adds();
          }, 1500);
        }))))
    })()
}();

// Global function to hide specific product from Globo app
function hideProduct9698992849177() {
  // Target Globo app product elements
  const productElements = document.querySelectorAll('[data-gw-product-id="9698992849177"]');
  productElements.forEach(function(element) {
    if (element.closest('.card')) {
      element.closest('.card').style.display = 'none';
    }
  });
  
  // Also target any elements with the product ID in various formats
  const alternativeSelectors = [
    '[data-product-id="9698992849177"]',
    '[data-id="9698992849177"]',
    '.spf-product-card[data-product-id="9698992849177"]',
    '.card[data-product-id="9698992849177"]'
  ];
  
  alternativeSelectors.forEach(function(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
      if (element.closest('.card')) {
        element.closest('.card').style.display = 'none';
      } else {
        element.style.display = 'none';
      }
    });
  });
}

// Hide product on page load
document.addEventListener('DOMContentLoaded', function() {
  hideProduct9698992849177();
});

// Set up global mutation observer for dynamic content
const globalObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      hideProduct9698992849177();
    }
  });
});

// Start observing the entire document for dynamic content
if (document.body) {
  globalObserver.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener("globoFilterRenderCompleted", function(e) {

   ! function() {
    "use strict";
    var t, e = {
            4105: function(t, e, n) {
                n.d(e, {
                    Q2: function() {
                        return o
                    },
                    gp: function() {
                        return s
                    },
                    hO: function() {
                        return r
                    }
                });
                const o = function() {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length>0&&void 0!==arguments[0]?arguments[0]:"json"}`
                            }
                        }
                    },
                    r = function() {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const e = window.innerWidth - document.body.offsetWidth,
                            n = document.getElementById("nav-wrapper");
                        t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", n.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", n.style.paddingRight = "0px")
                    };
                let a = () => {};
                const c = t => {
                        "Escape" === t.key && (a(), window.removeEventListener("keydown", c))
                    },
                    s = function() {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            e = arguments.length > 1 ? arguments[1] : void 0;
                        e && (a = e), t && window.addEventListener("keydown", c), t || window.removeEventListener("keydown", c)
                    };
                document.querySelectorAll(".local-scroll").forEach((t => {
                    t.addEventListener("click", (t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        (t => {
                            Math.easeInOutQuad = function(t, e, n, o) {
                                return (t /= o / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
                            };
                            const e = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let o = 0,
                                r = 0;
                            e && (o = e.offsetHeight + 50), n && (r = n.offsetHeight + 50);
                            const a = t.offsetTop - o - r,
                                c = window.scrollY,
                                s = a - c;
                            let i = 0;
                            const d = () => {
                                i += 5;
                                const t = Math.easeInOutQuad(i, c, s, 200);
                                window.scrollTo(0, t), i < 200 && setTimeout(d, 5)
                            };
                            d()
                        })(document.querySelector(e))
                    }))
                }))
            }
        },
        n = {};

    function o(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var a = n[t] = {
            exports: {}
        };
        return e[t](a, a.exports, o), a.exports
    }
    o.d = function(t, e) {
        for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        })
    }, o.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, t = o(4105), (() => {
        const e = document.querySelectorAll('form[action="/cart/add"]'),
            n = document.getElementById("main-cart"),
            o = document.getElementById("overlay"),
            r = document.getElementById("mini-cart"),
            a = document.querySelector("cart-service"),
            c = document.querySelector("body"),
            s = () => {
                r.classList.remove("open"), o.classList.remove("open"), c.style.removeProperty("overflow"), (0, t.hO)(!1)
            };
        e.length && e.forEach((e => e.addEventListener("submit", (c => {
            c.preventDefault(), c.stopPropagation(), c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`), c.target.querySelector('button[type="submit"]').classList.add("added"), c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "block";
            const i = (0, t.Q2)("javascript");
            i.headers["X-Requested-With"] = "XMLHttpRequest", delete i.headers["Content-Type"];
            const d = new FormData(e);
            d.append("sections", "main-cart"), i.body = d, fetch(`${routes.cartAdd}`, i).then((t => t.json())).then((async e => {
                if (e.status) {
                    if (c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "inline-flex", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none", c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof e.description) return Object.entries(e.description).forEach((t => {
                        let [e, n] = t;
                        const o = `${n.join(", ")}`;
                        c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + o + "</p>"
                    }));
                    c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>"
                } else {
                    if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
                    c.target.querySelector(".product-converter__error").innerHTML = "", n && n.classList.add("added"), a.renderItems((new DOMParser).parseFromString(e.sections["main-cart"], "text/html")), "mini-cart" === cartStrings.uxCart && (r && r.classList.add("open"), o && (o.classList.add("open", "overlay--all"), (0, t.hO)(!0), (0, t.gp)(!0, s))), c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), c.target.querySelector('button[type="submit"]').classList.remove("added"), c.target.querySelector('button[type="submit"]').classList.add("successful"), c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "flex", c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none"
                }
            })).catch((t => {
                console.error("Error:", t)
            }))
        }))))
    })()
}();
   
 });